import FilterHelper from '../../helpers/filterHelper';
import { formatQueryStringURL } from '../../helpers/formatQueryStringHelper';
import { axiosGet, axiosPost } from '../../services/axiosService';

const baseReportingURL = 'Reporting';

export class ReportsService {
	getInvestorsSignUp(currentPage = 1, perPage = 10) {
		return axiosGet(
			null,
			`${baseReportingURL}/GetInvestorsSignUp?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}

	exportInvestorsSignUp() {
		return axiosGet(
			null,
			`${baseReportingURL}/ExportInvestorsSignUp`,
			null,
			'blob'
		);
	}

	getInvestorsDeposit(currentPage = 1, perPage = 10) {
		return axiosGet(
			null,
			`${baseReportingURL}/GetInvestorDepositsReport?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}

	exportInvestorsDeposit() {
		return axiosGet(
			null,
			`${baseReportingURL}/ExportInvestorDepositsReport`,
			null,
			'blob'
		);
	}

	getInvestorsWithdrawal(currentPage = 1, perPage = 10) {
		return axiosGet(
			null,
			`${baseReportingURL}/InvestorWithdrawalsReport?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}

	exportInvestorsWithdrawal() {
		return axiosGet(
			null,
			`${baseReportingURL}/ExportInvestorWithdrawalsReport`,
			null,
			'blob'
		);
	}

	getBorrowersSignUp(currentPage = 1, perPage = 10) {
		return axiosGet(
			null,
			`${baseReportingURL}/GetBorrowersSignUp?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}

	exportBorrwersSignUp() {
		return axiosGet(
			null,
			`${baseReportingURL}/ExportBorrowersSignUp`,
			null,
			'blob'
		);
	}

	exportMarketingReport(urlQuery) {
		let query = urlQuery ? FilterHelper.mapToParams(urlQuery) : null;
		query = query?.startsWith('&') ? query.substring(1) : query;
		return axiosGet(
			null,
			`${baseReportingURL}/ExportInvestorsMarketingReport${query ? '?' + query : ''}`,
			null,
			'blob'
		);
	}

	getApprovedLendersReport(currentPage = 1, perPage = 10, filter) {
		let params = formatQueryStringURL(
			`?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}${filter ? `&${FilterHelper.mapToParams(filter, false)}` : ''
			}`
		);
		return axiosGet(
			null,
			`${baseReportingURL}/GetApprovedLendersReport` + params
		);
	}

	exportApprovedLendersReport() {
		return axiosGet(
			null,
			`${baseReportingURL}/ExportApprovedLendersReport`,
			null,
			'blob'
		);
	}

	getBorrowerShareholders() {
		return axiosGet(null, `${baseReportingURL}/GetBorrowerShareholders`);
	}

	getDFSAReport() {
		return axiosGet(null, `${baseReportingURL}/dfsa/regions-report`);
	}

	getDFSAOpportunityReport(filter) {
		let params = filter ? formatQueryStringURL(
			`${`?${FilterHelper.mapToParams(filter, false)}`}`
		) : "";
		return axiosGet(null, `${baseReportingURL}/dfsa/investors-in-opportunities-report` + params);
	}

	exportDFSAOpportunityReport(filter) {
		let params = filter ? formatQueryStringURL(
			`${`?${FilterHelper.mapToParams(filter, false)}`}`
		) : "";
		return axiosGet(
			null,
			`${baseReportingURL}/dfsa/investors-in-opportunities-report/export` + params,
			null,
			'blob'
		);
	}

	getCRSData(currentPage = 1, perPage = 10, filter) {
		let params = formatQueryStringURL(
			`?CurrentPage=${currentPage}&PerPage=${perPage}${filter ? `&${FilterHelper.mapToParams(filter, false)}` : ''
			}`
		);
		return axiosGet(
			null,
			`${baseReportingURL}/InvestorsCRS` + params
		);
	}

	getPromoCodeReport(currentPage = 1, perPage = 10) {
		return axiosGet(
			null,
			`PromoCodes/usages?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}

	getAcquisitionReport(currentPage = 1, perPage = 10) {
		return axiosGet(
			null,
			`${baseReportingURL}/acquisitionReport?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}

	getMarketingReports(currentPage = 1, perPage = 10, fromDate = "", toDate = "") {
		let url = `${baseReportingURL}/InvestorsMarketingReport?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`;
		if (fromDate) url += `&fromDate=${encodeURIComponent(fromDate)}`;
		if (toDate) url += `&toDate=${encodeURIComponent(toDate)}`;
		return axiosGet(null, url);
  	}

	getCorporateInvestorShareholders() {
		return axiosGet(null, `${baseReportingURL}/GetInvestorsShareholders`);
	}

	exportBorrowerShareholders() {
		return axiosGet(
			null,
			`${baseReportingURL}/ExportBorrowerShareholders`,
			null,
			'blob'
		);
	}

	exportCrsData() {
		return axiosGet(
			null,
			`${baseReportingURL}/ExportInvestorsCRS`,
			null,
			'blob'
		);
	}

	exportPromoCodeReport() {
		return axiosGet(
			null,
			`PromoCodes/usages/export`,
			null,
			'blob'
		);
	}

	exportInvestorShareholders() {
		return axiosGet(
			null,
			`${baseReportingURL}/ExportInvestorsShareholders`,
			null,
			'blob'
		);
	}

	getAecb(startDate, endDate) {
		let params = {
			startDate: startDate,
			endDate: endDate,
		};
		return axiosGet(params, `${baseReportingURL}/aecb`);
	}

	createAecb(modeType) {
		return axiosPost({ modeType }, `${baseReportingURL}/aecb`, {
			hide_success_toaster: true,
		});
	}

	getContractFile(id) {
		return axiosGet(
			null,
			`${baseReportingURL}/AecbContractFile/${id}`,
			null,
			'blob'
		);
	}

	getSubjectFile(id) {
		return axiosGet(
			null,
			`${baseReportingURL}/AecbSubjectFile/${id}`,
			null,
			'blob'
		);
	}

	getUserSurveyList(currentPage = 1, perPage = 200, filter = '') {
		let params = formatQueryStringURL(
			`?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}${filter ? `&${FilterHelper.mapToParams(filter, false)}` : ''
			}`
		);
		return axiosGet(
			null,
			`Lenders/Survey` + params
		);
	}

	getLoanTapeReport(currentPage = 1, perPage = 10) {
		return axiosGet(
			null,
			`${baseReportingURL}/LoanTapeReport?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}	

	exportLoanTapeReport() {
		return axiosGet(
			null,
			`${baseReportingURL}/ExportLoanTapeReport`,
			null,
			'blob'
		);
	}
}

